import { Injectable } from '@angular/core';
import { TokenServices } from './TokenServices';
import { tokenDetail } from '../Models/tokenDetail';
// import { } from '../../../wwwroot/images/'

@Injectable()
export class UtilityServices {
  isSession(): Promise<boolean> {
    if (typeof (Storage) !== 'undefined') {
      if (sessionStorage.getItem['User']) {
        return Promise.resolve(true);
      }
    }
    return Promise.resolve(false);
  }

}

@Injectable()
export class CheckAuth {
  moonLanding: Date;
  currentTime: Date;

  constructor(private tokenService: TokenServices) {

  }

  GetToken(): void {    
    this.tokenService.getAuthentication().subscribe(t => {
      this.moonLanding = new Date();
      //this.token.status = t["tokenDetail"].status;
      //this.token.token = t["tokenDetail"].token;
      //this.token.tokenExpiry = t["tokenDetail"].tokenExpiry;
      sessionStorage.setItem('tokenValue', t["tokenDetail"].token);
      sessionStorage.setItem('tokenExpiryValue', t["tokenDetail"].tokenExpiry);
      sessionStorage.setItem('appStartTime', this.moonLanding.toString());
    }
    );
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    if (startDate != null) {
      this.currentTime = new Date();
      let time = this.currentTime.getTime() - (new Date(startDate).getTime());
      time = time / 1000;
      time = time / 60;
      time = Math.round(Math.abs(time));
      if (parseInt(time.toString()) > (parseInt(tokenExpiry) - 2)) {
        this.GetToken();
      }
    }
    else {
      this.GetToken();
    }
  }
}
